<template>
  <div class="dojos">
    <TopBar />
    <h2>Dojos</h2>

    <div v-for="region in regions" :key="region.name" class="region-section">
      <h3 class="region-title">{{ region.name }}</h3>
      <div class="dojo-list">
        <div v-for="dojo in region.dojos" :key="dojo.name" class="dojo">
          <h4>{{ dojo.name }}</h4>
          <p><strong>Sensei:</strong> {{ dojo.sensei }}</p>
          <p><strong>Localização:</strong> {{ dojo.location }}</p>
          <p><strong>Direção:</strong> {{ dojo.address }}</p>
          <a :href="dojo.maps" target="_blank" class="maps-link">📍 Ver no Google Maps</a>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import TopBar from '../components/TopBar.vue';
import Footer from '../components/Footer.vue';

export default {
  name: 'Dojos',
  components: { TopBar, Footer },
  data() {
    return {
      regions: [
        {
          name: 'Norte',
          dojos: [
            { name: 'Dojo do Porto', sensei: 'Maria Costa', location: 'Porto', address: 'Rua de Santa Catarina, 45', maps: 'https://maps.app.goo.gl/Sz5XWCB4pTnPocar6' },
            { name: 'Dojo de Braga', sensei: 'Carlos Mendes', location: 'Braga', address: 'Avenida da Liberdade, 88', maps: 'https://maps.app.goo.gl/Sz5XWCB4pTnPocar6' },
            { name: 'Dojo de Vila Real', sensei: 'Nuno Carvalho', location: 'Vila Real', address: 'Avenida Carvalho Araújo, 60', maps: 'https://maps.app.goo.gl/Sz5XWCB4pTnPocar6' },
            { name: 'Dojo de Bragança', sensei: 'Marta Ribeiro', location: 'Bragança', address: 'Rua Almirante Reis, 14', maps: 'https://maps.app.goo.gl/Sz5XWCB4pTnPocar6' },
            { name: 'Dojo de Viana do Castelo', sensei: 'Luís Fernandes', location: 'Viana do Castelo', address: 'Rua Manuel Espregueira, 77', maps: 'https://maps.app.goo.gl/Sz5XWCB4pTnPocar6' },
            { name: 'Dojo de Guimarães', sensei: 'Paulo Araújo', location: 'Guimarães', address: 'Rua de Gil Vicente, 29', maps: 'https://maps.app.goo.gl/Sz5XWCB4pTnPocar6' },
            { name: 'Dojo de Matosinhos', sensei: 'Clara Vieira', location: 'Matosinhos', address: 'Rua Brito Capelo, 62', maps: 'https://maps.app.goo.gl/Sz5XWCB4pTnPocar6' },
            { name: 'Dojo de Gondomar', sensei: 'Fábio Moreira', location: 'Gondomar', address: 'Rua de São Pedro, 44', maps: 'https://maps.app.goo.gl/Sz5XWCB4pTnPocar6' },
            { name: 'Dojo de Vila Nova de Gaia', sensei: 'Sara Cardoso', location: 'Vila Nova de Gaia', address: 'Avenida da República, 99', maps: 'https://maps.app.goo.gl/Sz5XWCB4pTnPocar6' },
          ],
        },
        {
          name: 'Centro',
          dojos: [
            { name: 'Dojo de Coimbra', sensei: 'Ana Ferreira', location: 'Coimbra', address: 'Rua Ferreira Borges, 33', maps: 'https://maps.app.goo.gl/Sz5XWCB4pTnPocar6' },
            { name: 'Dojo de Aveiro', sensei: 'Miguel Rodrigues', location: 'Aveiro', address: 'Rua dos Mercadores, 9', maps: 'https://maps.app.goo.gl/Sz5XWCB4pTnPocar6' },
            { name: 'Dojo de Viseu', sensei: 'Sofia Pereira', location: 'Viseu', address: 'Rua Direita, 41', maps: 'https://maps.app.goo.gl/Sz5XWCB4pTnPocar6' },
            { name: 'Dojo de Leiria', sensei: 'Hugo Martins', location: 'Leiria', address: 'Rua Barão de Viamonte, 56', maps: 'https://maps.app.goo.gl/Sz5XWCB4pTnPocar6' },
            { name: 'Dojo de Guarda', sensei: 'Inês Almeida', location: 'Guarda', address: 'Rua Francisco de Passos, 7', maps: 'https://maps.app.goo.gl/Sz5XWCB4pTnPocar6' },
            { name: 'Dojo de Castelo Branco', sensei: 'Tiago Sousa', location: 'Castelo Branco', address: 'Avenida 1º de Maio, 30', maps: 'https://maps.app.goo.gl/Sz5XWCB4pTnPocar6' },
            { name: 'Dojo de Santarém', sensei: 'Beatriz Nunes', location: 'Santarém', address: 'Rua Serpa Pinto, 18', maps: 'https://maps.app.goo.gl/Sz5XWCB4pTnPocar6' },
            { name: 'Dojo de Torres Vedras', sensei: 'Alexandre Dias', location: 'Torres Vedras', address: 'Rua 9 de Abril, 53', maps: 'https://maps.app.goo.gl/Sz5XWCB4pTnPocar6' },
          ],
        },
        {
          name: 'Sul',
          dojos: [
            { name: 'Dojo Central de Lisboa', sensei: 'João Silva', location: 'Lisboa', address: 'Rua Augusta, 12', maps: 'https://maps.app.goo.gl/Sz5XWCB4pTnPocar6' },
            { name: 'Dojo de Faro', sensei: 'Pedro Lopes', location: 'Faro', address: 'Rua de Santo António, 67', maps: 'https://maps.app.goo.gl/Sz5XWCB4pTnPocar6' },
            { name: 'Dojo de Setúbal', sensei: 'Ricardo Santos', location: 'Setúbal', address: 'Rua do Bocage, 15', maps: 'https://maps.app.goo.gl/Sz5XWCB4pTnPocar6' },
            { name: 'Dojo de Évora', sensei: 'Teresa Oliveira', location: 'Évora', address: 'Praça do Giraldo, 22', maps: 'https://maps.app.goo.gl/Sz5XWCB4pTnPocar6' },
            { name: 'Dojo de Beja', sensei: 'André Gomes', location: 'Beja', address: 'Rua de Mértola, 25', maps: 'https://maps.app.goo.gl/Sz5XWCB4pTnPocar6' },
            { name: 'Dojo de Portalegre', sensei: 'Catarina Lima', location: 'Portalegre', address: 'Rua 19 de Junho, 3', maps: 'https://maps.app.goo.gl/Sz5XWCB4pTnPocar6' },
            { name: 'Dojo da Amadora', sensei: 'Filipa Teixeira', location: 'Amadora', address: 'Avenida Gago Coutinho, 50', maps: 'https://maps.app.goo.gl/Sz5XWCB4pTnPocar6' },
            { name: 'Dojo de Almada', sensei: 'Rui Baptista', location: 'Almada', address: 'Rua Capitão Leitão, 38', maps: 'https://maps.app.goo.gl/Sz5XWCB4pTnPocar6' },
            { name: 'Dojo de Oeiras', sensei: 'Joana Monteiro', location: 'Oeiras', address: 'Rua Prof. Reinaldo dos Santos, 20', maps: 'https://maps.app.goo.gl/Sz5XWCB4pTnPocar6' },
            { name: 'Dojo de Cascais', sensei: 'Diogo Pinto', location: 'Cascais', address: 'Rua Frederico Arouca, 11', maps: 'https://maps.app.goo.gl/Sz5XWCB4pTnPocar6' },
            { name: 'Dojo de Sintra', sensei: 'Leonor Correia', location: 'Sintra', address: 'Rua Consiglieri Pedroso, 5', maps: 'https://maps.app.goo.gl/Sz5XWCB4pTnPocar6' },
          ],
        },
        {
          name: 'Madeira',
          dojos: [
            { name: 'Dojo de Funchal', sensei: 'Vasco Freitas', location: 'Funchal', address: 'Rua da Carreira, 36', maps: 'https://maps.app.goo.gl/Sz5XWCB4pTnPocar6' },
          ],
        },
        {
          name: 'Açores',
          dojos: [
            { name: 'Dojo de Ponta Delgada', sensei: 'Mariana Rocha', location: 'Ponta Delgada', address: 'Rua Machado dos Santos, 8', maps: 'https://maps.app.goo.gl/Sz5XWCB4pTnPocar6' },
          ],
        },
      ],
    };
  },
};
</script>

<style scoped>
.dojos {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.region-section {
  width: 100%;
  padding: 1.5rem 1rem;
  text-align: center;
}
.region-title {
  font-size: 1.5rem;
  color: #333;
  border-bottom: 2px solid #e53935;
  display: inline-block;
  padding-bottom: 0.3rem;
  margin-bottom: 1rem;
}
.dojo-list {
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
  justify-content: center;
  padding: 0 1rem;
}
.dojo {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  padding: 1rem;
  min-width: 220px;
  max-width: 280px;
  text-align: left;
}
.dojo h4 {
  margin: 0 0 0.5rem;
  color: #e53935;
}
.maps-link {
  display: inline-block;
  margin-top: 0.5rem;
  color: #1a73e8;
  text-decoration: none;
  font-weight: bold;
  font-size: 0.9rem;
}
.maps-link:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .dojo-list {
    gap: 1rem;
    padding: 0 0.5rem;
  }
  .dojo {
    min-width: 0;
    max-width: none;
    width: calc(50% - 0.5rem);
  }
}

@media (max-width: 480px) {
  .region-section {
    padding: 1rem 0.5rem;
  }
  .region-title {
    font-size: 1.2rem;
  }
  .dojo-list {
    flex-direction: column;
    align-items: center;
  }
  .dojo {
    width: 100%;
    max-width: 100%;
  }
}
</style>

